import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showMoreRecommendations } from '../../../recommendations/actions/ShowMoreRecommendationsAction';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { RecommendationSpaceDispatchProps, RecommendationsSpace, RecommendationsSpaceStateProps } from './RecommendationsSpace';

const mapStateToProps: MapStateToProps<RecommendationsSpaceStateProps> = (state: AppState) => ({
  allRecsById: state.recommendations.recommendationsChannelState.items,
  isFetching: state.recommendations.recommendationsChannelState.isFetching,
  showMoreState: state.recommendations.recommendationsShowMoreState
});

const mapDispatchToProps: MapDispatchToProps<RecommendationSpaceDispatchProps> = (dispatch) => bindActionCreators({
  showMoreRecommendations
}, dispatch);

export const ConnectedRecommendationsSpace: React.ComponentClass
  = connect(mapStateToProps, mapDispatchToProps)(RecommendationsSpace);
